<template>
  <fb-form-body>
    <el-form :model="formData" ref="form" label-width="150px" class="fb-form">

      <el-form-item :label="$t('lang.子品牌')" prop="subBrand">
        <div style="display:flex;">
          <el-select v-model="formData.subBrand" value-key="code" @change="handleChangeSubBrand" :placeholder="$t('lang.请选择')">
            <el-option v-for="sub in subBrandList" :key="sub.code" :label="sub.name" :value="sub"></el-option>
          </el-select>
          <span class="input-row">{{ $t('lang.子品牌编号') }}：{{ formData.subBrand['number'] }}</span>
        </div>
      </el-form-item>

      <el-form-item :label="$t('lang.适配型号')" prop="subBrandProduct">
        <div style="display:flex;">
          <el-select v-model="formData.subBrandProduct" value-key="productCode" :placeholder="$t('lang.请选择')">
            <el-option v-for="product in subBrandProductList" :key="product.productCode" :label="product.productModel"
                       :value="product"></el-option>
          </el-select>
          <span class="input-row">{{ $t('lang.子型号名称') }}：{{ formData.subBrandProduct['subModel'] }}</span>
        </div>
      </el-form-item>






      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.保存资料') }}</el-button>
        <el-button type="primary" @click="handleApproval('form')">{{ $t('lang.提交审核') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import UploadFile from "../../components/upload-file/UploadFile";
import {loadDict, loadSubBrandProduct} from "../../js/common";
import {debounce} from "../../utlis/utlis";

export default {
  name: "DoorTypeEdit",
  components: {UploadFile},
  data() {
    return {
      api: {
        update: this.$api.subApk.update,
        detail: this.$api.subApk.detail,
        commitApproval: this.$api.subApk.commitApproval,
        upload: this.$api.file.upload,
        download: this.$api.file.download,
      },
      formData: {
        subBrand: {},
        subBrandProduct: {},
        video: '',
        logo: '',
        screen: [],
        accountBackground: '',
        recipeBackground: '',
        networkBackground: '',
        modeBackground: '',
      },
      tableData: [],
      subBrandProductList: [],
      modelInfo: [],
      that: this,
      chunkSize: 1024 * 10000,

      imgData: {
        logoList: [],
        accountBackgroundList: [],
        recipeBackgroundList: [],
        networkBackgroundList: [],
        modeBackgroundList: [],
        screenList: []
      }
    }
  },
  computed: {
    rules() {
      let checkSubBrand = (rule, value, callback) => {
        if (!Object.keys(this.formData.subBrand).length) {
          return callback(new Error(this.$t('lang.子品牌不能为空')))
        }
        return callback();
      };
      let checkSubBrandProduct = (rule, value, callback) => {
        if (!Object.keys(this.formData.subBrandProduct).length) {
          return callback(new Error(this.$t('lang.适配型号不能为空')))
        }
        return callback();
      };


      let checkLogo = (rule, value, callback) => {
        if (!this.formData.logo) {
          return callback(new Error(this.$t('lang.开机logo不能为空')))
        }
        return callback();
      };

      let checkVideo = (rule, value, callback) => {
        if (!this.formData.video) {
          return callback(new Error(this.$t('lang.开机视频不能为空')))
        }
        return callback();
      };

      let checkScreen = (rule, value, callback) => {
        if (!this.formData.screen.length) {
          return callback(new Error(this.$t('lang.屏幕保护图不能为空')))
        }
        return callback();
      };

      let checkAccountBackground = (rule, value, callback) => {
        if (!this.formData.accountBackground) {
          return callback(new Error(this.$t('lang.账户背景图不能为空')))
        }
        return callback();
      };

      let checkRecipeBackground = (rule, value, callback) => {
        if (!this.formData.recipeBackground) {
          return callback(new Error(this.$t('lang.食谱入口背景图不能为空')))
        }
        return callback();
      };

      let checkNetworkBackground = (rule, value, callback) => {
        if (!this.formData.networkBackground) {
          return callback(new Error(this.$t('lang.网络食谱入口背景不能为空')))
        }
        return callback();
      };

      let checkModeBackground = (rule, value, callback) => {
        if (!this.formData.modeBackground) {
          return callback(new Error(this.$t('lang.模式入口背景图不能为空')))
        }
        return callback();
      };

      let checkModel = (rule, value, callback) => {
        let mark = false;
        let errorText = '';
        let data = this.modelInfo;

        if (!data.length) {
          return callback(new Error(this.$t('lang.模式图片不能为空')))
        }

        for (let i = 0; i < data.length; i++) {
          if (!data[i].bg.length) {
            mark = true;
            errorText = `${data[i].value}${this.$t('lang.模式背景图不能为空')}`;
            break;
          } else if (!data[i].icon.length) {
            mark = true;
            errorText = `${data[i].value}${this.$t('lang.模式图标不能为空')}`;
            break;
          }
        }
        if (mark) {
          return callback(new Error(errorText))
        }
        return callback();
      };
      return {
        subBrand: [
          {required: true,  validator: checkSubBrand, trigger: 'change'}
        ],
        subBrandProduct: [
          {required: true,  validator: checkSubBrandProduct, trigger: 'change'}
        ],
        logo: [
          {required: true, validator: checkLogo, trigger: 'change'}
        ],
        video: [
          {required: true, validator: checkVideo, trigger: 'change'}
        ],
        screen: [
          {required: true, validator: checkScreen, trigger: 'change'}
        ],
        accountBackground: [
          {required: true, validator: checkAccountBackground, trigger: 'change'}
        ],
        recipeBackground: [
          {required: true, validator: checkRecipeBackground, trigger: 'change'}
        ],
        networkBackground: [
          {required: true, validator: checkNetworkBackground, trigger: 'change'}
        ],
        modeBackground: [
          {required: true, validator: checkModeBackground, trigger: 'change'}
        ],
        model: [
          {required: true, validator: checkModel, trigger: 'change'}
        ],


      }
    },
    subBrandList() {
      const vm = this;
      let list = this.$store.state.subBrandList;
      if (list.length == 1) {
        vm.formData.subBrand = list[0];
      }
      return list;
    },
  },
  methods: {
    handleBeforeUpload(file) {
      if(file.type.split('/')[0] != 'image') {
        this.$message.error('请上传图片格式文件')
        return false;
      }
      return true;
    },
    handleApproval: debounce(function (form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          vm.$http.get(vm.api.commitApproval,{params: vm.$route.query}).then(res => {
            if(res.data.status != 200) {
              vm.$message.error(res.data.desc);
              return;
            }

            vm.$message.success('提交成功');
            vm.$router.back();

          })
        }
      });
    }, 3000, true),

    handleRemoveImg(e, key, type) {
      console.log('删除图片', e,)
      const vm = this;
      if (e.status == "success") {
        let fileCode = e.response ? e.response.data.fileCode : e.fileCode;
        if (type == 'array') {
          let index = vm.formData[key].findIndex(i => i == fileCode);
          console.log('index', index)
          if (index == -1) {
            vm.$message.error('没有该图片')
            return;
          }
          vm.formData[key].splice(index, 1);
        } else {
          vm.formData[key] = '';
        }

      }
    },
    handleUploadImg(e, key, type = 'string') {
      const vm = this;
      if (e.status == "success") {
        let {response: res} = e;
        if (res.status != 200) {
          vm.$message.error(res.desc);
          return;
        }

        if (type == 'array') {
          this.formData[key].push(res.data.fileCode);
        } else {
          this.formData[key] = res.data.fileCode;
        }

        this.$refs.form.clearValidate(key)
      }
    },

    handleUploadVideo(e) {
      let {type} = e.file;
      if(type && type.split('/')[0] != 'video') {
        this.$message.error('上传文件格式错误');
        return;
      }
      console.log("视频上传", e)
      this.formData.video = e.data.fileCode;
    },

    handleRemoveVideo() {
      this.formData.video = '';
    },

    handleRemoveFile(row, key) {
      let index = this.tableData.findIndex(i => i.value == row.value);
      if (index != -1) {
        this.tableData[index][key] = [];
        console.log('删除了', this.tableData)
      }
    },
    handleChangeModel(e) {
      console.log("改变模式", e);
    },
    // 模式图片上传
    handleUploadFile(file, img) {
      const vm = this;
      if (file.status == "success") {
        let {response: res, uid} = file;
        if (res.status != 200) {
          vm.$message.error(res.desc);
          return;
        }
        let fileInfo = {url: `${vm.api.download}?fileCode=${res.data.fileCode}`, id: uid, fileCode: res.data.fileCode};
        img.push(fileInfo);
      }

    },
    async handleChangeSubBrand(e) {
      this.subBrandProductList = [];
      this.formData.subBrandProduct = {};
      if (Object.keys(e).length) {
        this.subBrandProductList = await loadSubBrandProduct(this, e.code);
      }
    },
    handleRenderHeader(h, name, size) {
      return h('div',{
        attrs:{
          class:'label-title',
        },
        domProps:{
          innerHTML:`<span>${name}</span><span class="size">${size}</span>`,
        },
      });
    },

    handleSubmit: debounce(function (form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let data = {
            code: vm.$route.query.code,
          };

          let list = [];

          for (const key in vm.formData) {
            let obj = {};
            switch(key){
              case 'logo':
                obj['flag'] = 'start_logo';
                obj['type'] = 'system_image';
                obj['fileCode'] = vm.formData[key];
                break;
              case 'video':
                obj['flag'] = 'start_video';
                obj['type'] = 'system_image';
                obj['fileCode'] = vm.formData[key];
                break;
              case 'screen':
                vm.formData[key].forEach(i => {
                  let obj = {};
                  obj['flag'] = 'screen_protect_image';
                  obj['type'] = 'system_image';
                  obj['fileCode'] = i;
                  list.push(obj);
                });
                break;
              case 'accountBackground':
                obj['flag'] = 'account_background_image';
                obj['type'] = 'system_image';
                obj['fileCode'] = vm.formData[key];
                break;
              case 'recipeBackground':
                obj['flag'] = 'recipe_entry_background';
                obj['type'] = 'system_image';
                obj['fileCode'] = vm.formData[key];
                break;
              case 'modeBackground':
                obj['flag'] = 'mode_entry_background';
                obj['type'] = 'system_image';
                obj['fileCode'] = vm.formData[key];
                break;
              case 'networkBackground':
                obj['flag'] = 'network_recipe_entry_background';
                obj['type'] = 'system_image';
                obj['fileCode'] = vm.formData[key];
                break;
            }
            if(Object.keys(obj).length) {
              list.push(obj);
            }

          }

          this.modelInfo.forEach(i => {
            let bgObj = {
              fileCode: i.bg[0].fileCode,
              type: "mode_image",
              flag: 'mode_background_image',
              used: true,
              mode: i.value,
            }
            let iconObj = {
              fileCode: i.icon[0].fileCode,
              flag: 'mode_icon',
              type: "mode_image",
              used: true,
              mode: i.value,
            }
            list.push(bgObj);
            list.push(iconObj);
          });
          data['attachmentList'] = list;


          vm.$http.post(vm.api.update, data).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {

              vm.$message({
                type: "error",
                message: resp.data.desc
              });
            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    }, 3000, true),


    handleReset(form) {
      this.$refs[form].resetFields();
      this.modelInfo.forEach(i => {
        i.bg = [];
        i.icon = [];
      });
      this.modelInfo = [];
      for (const key in this.imgData) {
        this.imgData[key] = [];
      }
    },


    handleGetDetail() {
      let vm = this;
      this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (resp) {
        if(resp.data.status != 200) {
          vm.$message.error(resp.data.desc);
          return;
        }
        let data = resp.data.data['subApk'];
        // 回显子品牌
        vm.formData['subBrand'] = {
          code: data['subBrandCode'],
          name: data['subBrandName'],
          number: data['subBrandNumber'],
        }
        // 回显适配型号
        vm.handleChangeSubBrand(vm.formData['subBrand']);
        vm.formData['subBrandProduct'] = {
          productCode: data['productCode'],
          productModel: data['productModel'],
          subBrandProductCode: data['brandProductCode'],
          subModel: data['productSubModel']
        }
        // 回显图片
        let url = `${vm.api.download}?fileCode=`;
        vm.modelInfo = [];
        data['attachmentList'].forEach(i => {
          let imgObj = {};
          // 系统图片
          switch (i.flag) {
            case 'start_logo':
              vm.formData['logo'] = i.fileCode;
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              vm.imgData['logoList'].push(imgObj);
              imgObj = {};
              break;
            case 'start_video':
              vm.formData['video'] = i.fileCode;
              break;
            case 'screen_protect_image':
              vm.formData['screen'].push(i.fileCode);
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              vm.imgData['screenList'].push(imgObj);
              imgObj = {};
              break;
            case 'account_background_image':
              vm.formData['accountBackground'] = i.fileCode;
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              vm.imgData['accountBackgroundList'].push(imgObj);
              imgObj = {};
              break;
            case 'recipe_entry_background':
              vm.formData['recipeBackground'] = i.fileCode;
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              vm.imgData['recipeBackgroundList'].push(imgObj);
              imgObj = {};
              break;
            case 'mode_entry_background':
              vm.formData['modeBackground'] = i.fileCode;
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              vm.imgData['modeBackgroundList'].push(imgObj);
              imgObj = {};
              break;
            case 'network_recipe_entry_background':
              vm.formData['networkBackground'] = i.fileCode;
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              vm.imgData['networkBackgroundList'].push(imgObj);
              imgObj = {};
              break;

          }

          // 附件图片
          if(i.mode) {
            let item = vm.modelInfo.find(m => m.value == i.mode);

            if(item) {
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              let key = i.flag == 'mode_background_image' ? 'bg' : 'icon';
              item[key].push(imgObj);
              imgObj = {};
            } else {
              item = vm.tableData.find(t => t.value == i.mode);
              // item = {...item};
              imgObj = {url: url + i.fileCode, fileCode: i.fileCode};
              let key = i.flag == 'mode_background_image' ? 'bg' : 'icon';
              item[key].push(imgObj);
              vm.modelInfo.push(item);
              imgObj = {};
            }

          }


        })

        console.log('data', vm.modelInfo)

      });
    }
  },

  async created() {

    let data = await loadDict(this, 'WORK_MODE');
    this.tableData = data.map(i => {
      i.bg = [];
      i.icon = [];
      return i;
    });

    this.handleGetDetail();


  }
}
</script>

<style scoped>

.fb-form {
  max-width: 500px;
}

.tip-style {
  color: #ef1e57;
}

/deep/ .label-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/deep/ .label-title .size {
  color: #ef1e57;
  font-weight: 400;
  font-size: 12px;
}


.upload-icon {
  width: 148px;
  height: 148px;
  background: #fbfdff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px dashed #dddddd;
}

.upload-icon .el-icon-plus {
  font-size: 30px;
  color: #8c939d;
}

.upload-img-row {
  width: 148px;
  height: 148px;
  position: relative;
}

.upload-img {
  width: 148px;
  height: 148px;
  border-radius: 8px;
}

.upload-img-row:hover .upload-del {
  display: flex;
}

.upload-del {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: rgba(0, 0, 0, .4);
  align-items: center;
  justify-content: center;
  display: none;
  z-index: 9999;
}

.upload-del .el-icon-delete {
  font-size: 30px;
  color: #fff;
}

.input-row {
  margin-left: 12px;
  display: inline-block;
  width: 150px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 8px;
  background: #eee;
  color: #9595b3;
  font-size: 14px;
}

.video-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #eeeeee;
  padding: 0 14px 14px;
  border-radius: 10px;
}

.close-row {
  display: flex;
  justify-content: flex-end;
  margin: 12px 0;
}

.close-icon {
  font-size: 24px;
  color: red;
  width: 40px;
  text-align: right;
  cursor: pointer;
}

</style>
